import { makeAutoObservable } from "mobx";
import {
  pagingNewUsers,
  getUser,
  getUserByUsername,
  getUserByEmail,
  saveUser,
  deleteUser,
  saveUserHealthOrganizations,
  getListUserHealthOrgByUserId,
  pagingUserHealthOrg,
  saveUserKeyCloak,
  getListUserAdministrativeUnitByUserId,
  saveUserAdministrativeUnits,
  resetPasswordUserKeyCloak,
  getListUserRoleDetail,
  saveListUserRoleDetail,
  updateUserKeyCloak
} from "./UserService";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";

export default class UserStore {
  userList = [];
  roles = [];
  selectedUser = null;
  totalElements = 0;
  totalPages = 0;
  page = 1;
  rowsPerPage = 10;
  loadingInitial = false;
  shouldOpenEditorDialog = false;
  shouldOpenConfirmationDialog = false;
  searchObject = {
    keyword: "",
    organization: null,
    administrativeUnit: null,
    region: null,
    roleIds: [],
    sortUserName: null,
    sortDisplayName: null,
    sortEmail: null,
    sortRole: null,
    sortCreatedDate: null,
  };
  healthOrgDetailComponent = false;

  constructor() {
    makeAutoObservable(this);
  }

  setLoadingInitial = (state) => {
    this.loadingInitial = state;
  };

  updatePageData = (item) => {
    if (item != null) {
      this.page = 1;
      this.keyword = item.keyword;
      this.healthOrgId = item.healthOrgId;
      this.search();
    } else {
      this.search();
    }
  };

  search = async () => {
    this.setLoadingInitial(true);
    let searchObject = {
      pageIndex: this.page,
      pageSize: this.rowsPerPage,
      healthOrganizationId: this.healthOrgId,
      keyword: this.searchObject.keyword,
      organizationId: this.searchObject?.organization?.id,
      provinceId: this.searchObject?.administrativeUnit?.id,
      regionId: this.searchObject?.region?.id,
      roleIds: this.searchObject?.roleIds?.map((item) => item?.id),
      sortUserName: this.searchObject?.sortUserName,
      sortDisplayName: this.searchObject?.sortDisplayName,
      sortEmail: this.searchObject?.sortEmail,
      sortRole: this.searchObject?.sortRole,
      sortCreatedDate: this.searchObject?.sortCreatedDate,
    };

    if (this.healthOrgDetailComponent) {
      this.handlePagingUserHealthOrg(searchObject)
    } else {
      try {
        let res = await pagingNewUsers(searchObject);
        this.userList = res.data.content;
        this.totalElements = res.data.totalElements;
        this.totalPages = res.data.totalPages;
        this.setLoadingInitial(false);
      } catch (error) {
        console.log(error);
        this.setLoadingInitial(false);
      }
    }
    // this.setLoadingInitial(false);
  };

  handlePagingUserHealthOrg = async (searchObject) => {
    try {
      let data = await pagingUserHealthOrg(searchObject);
      this.userList = data.data.content;
      this.totalElements = data.data.totalElements;
      this.totalPages = data.data.totalPages;
      this.setLoadingInitial(false);
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
    }
  }

  setPage = (page) => {
    this.page = page;
    this.updatePageData();
  };

  setRowsPerPage = (event) => {
    this.rowsPerPage = event.target.value;
    this.page = 1;
    this.updatePageData();
  };

  handleChangePage = (event, newPage) => {
    this.setPage(newPage);
  };

  handleEditUser = (id) => {
    this.getUser(id).then(() => {
      this.shouldOpenEditorDialog = true;
    });
  };

  handleClose = () => {
    this.shouldOpenEditorDialog = false;
    this.shouldOpenConfirmationDialog = false;
    this.updatePageData();
  };

  handleDelete = (id) => {
    this.getUser(id).then(() => {
      this.shouldOpenConfirmationDialog = true;
    });
  };

  handleConfirmDelete = () => {
    this.deleteUser(this.selectedUser.id);
  };

  getUser = async (id) => {
    if (id != null) {
      try {
        let data = await getUser(id);
        this.selectedUser = data.data;
        let healths = await getListUserHealthOrgByUserId(id);
        let userAdministrativeUnit = await getListUserAdministrativeUnitByUserId(id);
        let userRoleDetail = await getListUserRoleDetail(id);
        
        if (healths.data != null) {
          this.selectedUser.healthOrganizations = healths.data;
        }
        if (userAdministrativeUnit.data != null) {
          this.selectedUser.userAdministrativeUnit = userAdministrativeUnit.data;
        }
        if (userRoleDetail?.data) {
          this.selectedUser.userRoleDetail = userRoleDetail.data;
        }
      } catch (error) {
        console.log(error);
        toast.warning("toast.get_fail");
      }
    } else {
      this.selectedUser = null;
    }
  };

  saveUser = async (user) => {
    // debugger;
    try {
      //  console.log(user);
      let data = await getUserByUsername(user.username);
      if (data.data != null && data.data.id != null) {
        if (!user.id || (user.id && data.data.id !== user.id)) {
          toast.warning('Tên đăng nhập đã tồn tại!', 'Thông báo');
        } else {
          let dataEmail = await getUserByEmail(user.email);
          if (dataEmail.data != null && dataEmail.data.id != null) {
            if (!user.id || (user.id && dataEmail.data.id !== user.id)) {
              toast.warning('Địa chỉ email đã tồn tại!', 'Thông báo');
            } else {
              await this.handleSaveUser(user);
            }
          } else {
            await this.handleSaveUser(user);
          }
        }
      } else {
        let dataEmail = await getUserByEmail(user.email);
        if (dataEmail.data != null && dataEmail.data.id != null) {
          if (!user.id || (user.id && dataEmail.data.id !== user.id)) {
            toast.warning('Địa chỉ email đã tồn tại!', 'Thông báo');
          }
        } else {
          await this.handleSaveUser(user);
        }
      }
    } catch (error) {
      console.log(error);
      toast.warning("Có lỗi xảy ra khi cập nhật!");
    }
  };

  handleSaveUser = async (user) => {
    //create
    if (!user.id || user?.id === "") {
      let resKeyCloak = await saveUserKeyCloak(user);
      if (resKeyCloak?.status === 200) {
        if (resKeyCloak.data?.isFaled && resKeyCloak?.data?.code !== "409") {
          // toast.error(resKeyCloak.data?.note || "")
          toast.error("Có lỗi xảy ra, vui lòng thử lại!")
          return;
        }
        let response = await saveUser(user);
        if (response?.data?.id) {
          saveUserHealthOrganizations(response.data.id, user.healthOrganizations);
          saveUserAdministrativeUnits(response.data.id, user.userAdministrativeUnit);
          saveListUserRoleDetail(response.data.id, user.userRoleDetail);
          toast.success("Thêm tài khoản thành công!");

          this.handleClose();
        }
      }
    } else {
      //edit
      const saveUserKeyCloak = await updateUserKeyCloak(user)
      if (saveUserKeyCloak?.status === 200) {
        if (saveUserKeyCloak.data?.isFaled && saveUserKeyCloak?.data?.code !== "409") {
          toast.error("Có lỗi xảy ra, vui lòng thử lại!")
          return;
        }
        let response = await saveUser(user);
        if (response?.data?.id) {
          saveUserHealthOrganizations(response.data.id, user.healthOrganizations);
          saveUserAdministrativeUnits(response.data.id, user.userAdministrativeUnit);
          saveListUserRoleDetail(response.data.id, user.userRoleDetail);
          if (user?.changePass) {
            resetPasswordUserKeyCloak(user).then(() => {
              toast.success("Cập nhật thành công!");
              this.handleClose();
            }).catch(e => {
              toast.error("Có lỗi xảy ra, vui lòng thử lại!")
            })
          } else {
            toast.success("Cập nhật thành công!");
            this.handleClose();
          }
        }
      }
    }
  }

  deleteUser = async (id) => {
    try {
      await deleteUser(id);
      toast.success("Đã xóa thành công!");
      this.handleClose();
    } catch (error) {
      console.log(error);
      toast.warning("toast.delete_fail");
    }
  };

  setHealthOrgDetailComponent = (state) => {
    this.healthOrgDetailComponent = state;
    if (!state) {
      this.healthOrgId = "";
    }
  }

  resetSearchObject = () => {
    this.page = 1;
    this.keyword = "";
    this.healthOrgId = null;
    this.rowsPerPage = 10;
    this.searchObject = {
      keyword: "",
      organization: null,
      administrativeUnit: null,
      region: null,
      roleIds: [],
      sortUserName: null,
      sortDisplayName: null,
      sortEmail: null,
      sortRole: null,
      sortCreatedDate: null,
    }
  }

  preHandleSubmitData = (values) => {
    const password = values?.password?.trim()
    const confirmPassword = values?.confirmPassword?.trim()
    const changePass = password && confirmPassword && password === confirmPassword
    return {
      ...values,
      person: {
        ...values?.person,
        displayName: values?.person?.displayName?.trim(),
      },
      email: values?.email?.trim(),
      changePass,
    }
  }

  handleSetSearchObject = item => {
    if (item.pageIndex) {
      this.page = item.pageIndex;
    }
    this.searchObject = {...item}
  }

  handleSetSortField = item => {
    this.page = 1;
    this.searchObject = {
      ...this.searchObject,
      //set các trường sort khác = null
      sortUserName: null,
      sortDisplayName: null,
      sortEmail: null,
      sortRole: null,
      sortCreatedDate: null,
      ...item,
    };
    this.updatePageData();
  }

}
